import { useSyncExternalStoreWithSelector } from 'use-sync-external-store/shim/with-selector';
import type { Store } from '../core/store';

/**
 * Read a slice of a store. The component re-renders only when `select` returns something that
 * `isEqual` says is different — pass `shallowEqual` when the selector builds an object.
 */
export function useStore<S, T>(
  store: Store<S>,
  select: (state: S) => T,
  isEqual: (a: T, b: T) => boolean = Object.is,
): T {
  return useSyncExternalStoreWithSelector(store.subscribe, store.get, store.get, select, isEqual);
}
